/* unplugin-vue-components disabled */import script from "./TrialFundGuideHost.vue?vue&type=script&setup=true&lang=js"
export * from "./TrialFundGuideHost.vue?vue&type=script&setup=true&lang=js"

import "./TrialFundGuideHost.vue?vue&type=style&index=0&id=f8ed8b30&lang=scss&scoped=true"

import exportComponent from "../../../../deepsage/deepsage_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8ed8b30"]])

export default __exports__